import React, { Fragment, useState, useEffect } from "react";
import { keyBy } from "lodash";
import { Box, Flex } from "rebass";
import { useQueryWithStore, Loading, TextField } from "react-admin";
import {
  CreateButton,
  RefreshButton,
  ButtonEditView,
  Pagination,
  RaDateField,
  Datagrid,
  ActiveField,
} from ".";
import { StyleTextField } from "../components";

const ListCustomer = (props) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [isRequest, setIsRequest] = useState(false);
  const { data, total, loading } = useQueryWithStore({
    type: "getList",
    resource: "promotions",
    payload: {
      pagination: { page, perPage },
      sort: { field: "type", order: "ASC" },
      filter: { type: "Customer", search: searchText },
    },
  });

  const handleChange = (name) => (event) => {
    if (name === "search") {
      setSearch(event.target.value);
    }
    setIsRequest(true);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (isRequest) {
        setSearchText(search);
        setIsRequest(false);
      }
    }, 500);
    return () => clearTimeout(timeout);
  });

  if (loading) {
    return (
      <Flex
        width={[1]}
        justifyContent={"center"}
        flexDirection={"column"}
        alignItems={"center"}
        style={{ height: "60vh" }}
      >
        <Loading />
      </Flex>
    );
  }
  return (
    <Box width={[1]} p={[2]}>
      <Flex width={[1]} justifyContent={"flex-end"} flexDirection={"row"}>
        <Box>
          <CreateButton
            basePath={"/promotions/customers"}
            sizeIcon={"xsmall"}
          />
        </Box>
        <Box>
          <RefreshButton sizeIcon={"xsmall"} />
        </Box>
      </Flex>

      <Flex
        width={[1]}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        pb={[2]}
      >
        <StyleTextField
          label='search'
          margin='dense'
          variant='filled'
          value={search}
          onChange={handleChange("search")}
          InputLabelProps={{ shrink: true }}
          style={{ width: 200 }}
        />
      </Flex>
      {data && (
        <Fragment>
          <Datagrid
            data={keyBy(data, "id")}
            ids={data.map(({ id }) => id)}
            currentSort={{ field: "type", order: "ASC" }}
            basePath='/promotions' // required only if you set use "rowClick"
            // rowClick="edit"
          >
            <TextField
              label={"resources.promotions.fields.name"}
              source='name'
            />
            <ActiveField
              label={"resources.promotions.fields.active"}
              source='active'
            />
            <RaDateField
              {...props}
              label={"resources.promotions.fields.start"}
              source='start_date'
            />
            <RaDateField
              {...props}
              label={"resources.promotions.fields.end"}
              source='end_date'
            />
            <ButtonEditView {...props} />
          </Datagrid>
          <Pagination
            page={page}
            perPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            setPage={(v) => setPage(v)}
            setPerPage={(v) => setPerPage(v)}
            total={
              total === null
                ? data && data.length > 0
                  ? data.length
                  : 0
                : total
            }
          />
        </Fragment>
      )}
    </Box>
  );
};

export default ListCustomer;
